import { __awaiter, __generator } from "tslib";
export var retryMiddleware = function retryMiddleware(options) {
  return function (next) {
    return function (args) {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , options.retryStrategy.retry(next, args)];
        });
      });
    };
  };
};
export var retryMiddlewareOptions = {
  name: "retryMiddleware",
  tags: ["RETRY"],
  step: "finalizeRequest",
  priority: "high"
};
export var getRetryPlugin = function getRetryPlugin(options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
    }
  };
};